import { MiniPkgPayment } from '@/api/payments/types/PkgPayment'
import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

export enum CouponTypeEnum {
  Percentage = 'PERCENTAGE',
  Fixed = 'FIXED',
  MktUniteFee = 'MktUniteFee',
  WarehouseFees = 'WarehouseFees',
}

export interface Coupon {
  country: (PkgWarehouse | 'all')[]
  minPayment: number
  maxDiscount?: number
  limitedUses: number
  expiredAt: string
  createdAt: string
  familyName: string
  usersAllowed: string[]
  value: number
  code: string
  shippingMethod: string
  revenue: number
  updatedAt: string
  notes: string
  productCategory: string
  id: string
  userId: string
  limitedUsesForUser: number
  type: CouponTypeEnum
}
export interface CouponWithPayments extends Coupon {
  payments: MiniPkgPayment[]
  totalPaymentRevenue: number
  totalFinalPayments: number
  timesUsed: number
}
